import { $inject, $type } from "../utils/di-container.js";
import { getBaseUrlByScript } from "../utils/url-utils.js";
import { FeatureService } from './feature.service.js';
import { supportedLanguages } from './i18n.service.js';

/**
 * Service used to hold and process URLs for accessing resources/dependencies.
 */
export class UrlService {

  /** @type {string} */
  clientBareHostname;

  /** @type {string} */
  baseUrl;

  /** @type {string} */
  baseUrlNormalized;

  /** @type {string} */
  siteUrl;

  /** @type {string} */
  certificateSiteUrl;

  /** @type {string} */
  styleUrl;

  /** @type {FeatureService} */
  _featureService

  constructor() {
    try {
      this.clientBareHostname = window.location.hostname.replace(/^www\./, '');
    } catch (e) {
    }
  }

  [$inject](obtain) {
    this._featureService = obtain(FeatureService);
  }

  /**
   * Initializes urls. Should be called before use.
   */
  init() {
    this.baseUrl =  getBaseUrlByScript('/badge-integrator/trustedretailers/badges.js', 1) || getBaseUrlByScript('/trustedretailers/badges.js') || getBaseUrlByScript('/badges.js') || getBaseUrlByScript('/badge/badge.js');
    if (!this.baseUrl) {
      throw new Error('Badge2 base url cannot be determined!');
    }
    this.baseUrlNormalized = this.baseUrl.replace('badge-app', 'app'); // to determine correct path even when running on own badge domain
    this.siteUrl = this.baseUrlNormalized.replace(/app\./, '');
    this.certificateSiteUrl = this.siteUrl;
    if (this.certificateSiteUrl.startsWith('http')) {
      // promote to https
      this.certificateSiteUrl = 'https://www.' + this.certificateSiteUrl.replace(/https?:\/\//, '');
    }
    if (this.certificateSiteUrl.startsWith('https://www.127.0.0.1')) {
      // support for local
      this.certificateSiteUrl = 'http://localhost:4200';
    }
    if (this.certificateSiteUrl.includes('/badge-integrator')) {
      // support integrator paths
      this.certificateSiteUrl = this.certificateSiteUrl.replace('/badge-integrator', '');
    }
    this.styleUrl = `${this.baseUrl}/trustedretailers/badge2-assets/badges.css`;
    this.baseApiUrl = `${this.baseUrlNormalized}/api`;
    this.badge2ApiUrl = environment => {
      if (environment === 'test') {
        return `${this.baseApiUrl}/badge/v2/sandbox`;
      } else if (environment === 'app') {
        return `${this.baseApiUrl}/badge/app`;
      } else {
        // default: live
        return `${this.baseApiUrl}/badge/v2`;
      }
    };
  }

  buildCertificateUrl(language, brandBareHostname, productId) {
    if (!supportedLanguages.includes(language)) {
      // fallback language
      language = 'en';
    }
    return [ this.certificateSiteUrl, 'certificate', language, 'authorized-partner', this.clientBareHostname, brandBareHostname, productId ]
      .filter(_ => !!_)
      .join('/') + '?source=badge';
  }

  getCurrentUrl() {
    return `${location.protocol}//${location.host}${location.pathname}`;
  }

}

UrlService[$type] = Symbol('UrlService');
